export const ROLE_KEYS = ["owner_admin", "office_planner", "operator"];
export const ROLE_LABELS = {
    owner_admin: "Owner / Admin",
    office_planner: "Office / Planner",
    operator: "Shop-floor Operator",
};
export const PERMISSION_KEYS = [
    "dashboard:owner",
    "dashboard:office",
    "shopfloor:view",
    "shopfloor:report",
    "customers:read",
    "quotes:manage",
    "sales:manage",
    "jobs:manage",
    "purchasing:manage",
    "finance:manage",
    "reports:ops",
    "reports:financial",
    "attachments:read",
    "attachments:write",
    "attachments:delete",
    "users:manage",
    "audit:read",
    "settings:manage",
];
const ALL = [...PERMISSION_KEYS];
const OFFICE = [
    "dashboard:office",
    "shopfloor:view",
    "customers:read",
    "quotes:manage",
    "sales:manage",
    "jobs:manage",
    "purchasing:manage",
    "finance:manage",
    "reports:ops",
    "attachments:read",
    "attachments:write",
];
const OPERATOR = [
    "shopfloor:view",
    "shopfloor:report",
    "attachments:read",
];
export const ROLE_PERMISSIONS = {
    owner_admin: ALL,
    office_planner: OFFICE,
    operator: OPERATOR,
};
export function permissionsFor(role) {
    return new Set(ROLE_PERMISSIONS[role]);
}
export function can(role, permission) {
    return ROLE_PERMISSIONS[role].includes(permission);
}
export function isRoleKey(value) {
    return ROLE_KEYS.includes(value);
}
//# sourceMappingURL=roles.js.map